import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useId } from 'react';
import { Input } from '../../components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));
const MINUTES = ['00', '30'];
function parseDateTimeValue(val) {
    if (!val)
        return { date: '', hour: '00', minute: '00' };
    let dateStr = '';
    let hour = '00';
    let minute = '00';
    if (typeof val === 'string') {
        if (val.includes('T')) {
            const [d, t] = val.split('T');
            dateStr = d;
            const timeParts = (t || '').split(':');
            hour = (timeParts[0] || '00').padStart(2, '0');
            const m = parseInt(timeParts[1] || '0', 10);
            minute = m >= 30 ? '30' : '00';
        }
        else {
            dateStr = val;
        }
    }
    else if (val instanceof Date) {
        dateStr = val.toISOString().split('T')[0];
        hour = String(val.getHours()).padStart(2, '0');
        minute = val.getMinutes() >= 30 ? '30' : '00';
    }
    else if (val && typeof val === 'object' && 'toISO' in val) {
        dateStr = val.toFormat?.('yyyy-MM-dd') ?? val.toISO?.()?.split('T')[0] ?? '';
        hour = String(val.hour ?? 0).padStart(2, '0');
        minute = (val.minute ?? 0) >= 30 ? '30' : '00';
    }
    return { date: dateStr, hour, minute };
}
function toDateTimeString(date, hour, minute) {
    if (!date)
        return '';
    return `${date}T${hour}:${minute}`;
}
const ShadcnDateTimeField = ({ formrValue, onUpdate, readonly = false }) => {
    // Names the date input; hour and minute are its own selects.
    const id = useId();
    const isDisabled = readonly || !formrValue.editable(formrValue.value);
    const [parts, setParts] = useState(() => parseDateTimeValue(formrValue.value));
    useEffect(() => {
        setParts(parseDateTimeValue(formrValue.value));
    }, [formrValue.value]);
    const validation = formrValue.validator(formrValue.value);
    const update = (newParts) => {
        setParts(newParts);
        onUpdate(formrValue.key, formrValue.setter(toDateTimeString(newParts.date, newParts.hour, newParts.minute)));
    };
    return (_jsxs("div", { className: "space-y-1", children: [_jsx("label", { htmlFor: id, className: "text-sm font-medium text-foreground", children: formrValue.label }), _jsxs("div", { className: "flex items-center gap-2", children: [_jsx(Input, { id: id, type: "date", value: parts.date, onChange: (e) => update({ ...parts, date: e.target.value }), disabled: isDisabled, "aria-invalid": !validation.isValid, className: "flex-1" }), _jsxs(Select, { value: parts.hour, onValueChange: (hour) => update({ ...parts, hour }), disabled: isDisabled, children: [_jsx(SelectTrigger, { className: "w-[70px]", children: _jsx(SelectValue, {}) }), _jsx(SelectContent, { children: HOURS.map((h) => (_jsx(SelectItem, { value: h, children: h }, h))) })] }), _jsx("span", { className: "text-sm font-medium text-muted-foreground", children: ":" }), _jsxs(Select, { value: parts.minute, onValueChange: (minute) => update({ ...parts, minute }), disabled: isDisabled, children: [_jsx(SelectTrigger, { className: "w-[70px]", children: _jsx(SelectValue, {}) }), _jsx(SelectContent, { children: MINUTES.map((m) => (_jsx(SelectItem, { value: m, children: m }, m))) })] })] }), !validation.isValid && (_jsx("p", { className: "text-sm text-destructive", children: validation.message }))] }));
};
export { ShadcnDateTimeField };
//# sourceMappingURL=ShadcnDateTimeField.js.map